import React from 'react'
import styled from 'styled-components'
import { Icon } from 'rsuite'

export default function SheetTitle ({ icon, text, style }) {
  return (
    <Container style={style}>
      <IconContainer>
        <Icon icon={icon} size="1x"/>
      </IconContainer>

      <Text>{text}</Text>
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

const IconContainer = styled.div`
  margin-right: 8px;
`

const Text = styled.p`
  font-size: 15px;
  font-weight: 800;
`
